module.exports = __webpack_public_path__ + "img/2.0a0bb2a4.png";